import React from 'react';
import { OnboardingFirstImage, OnboardingHeading, OnboardingDescription } from '../components/Content';
import peopleWalkingImage from '../../../assets/images/people_walking.png';
import fsRoundLogo from '../../../assets/images/fs_round_logo.jpg';

interface Step1Props {
  onNext: () => void;
}

const Step1: React.FC<Step1Props> = ({ onNext }) => {
  return (
    <div className="onboarding-step">
      <div className="step-content">
        <OnboardingFirstImage image={fsRoundLogo} />
        <OnboardingHeading text="Welcome to FlatSharing!" />
        <OnboardingDescription text="We're glad you're here 🙂"/>
        <OnboardingDescription text="Just answer a few quick questions to join the community. ✍️"/>
        <OnboardingDescription text="You'll get access to apartments 2–3 times cheaper than Airbnb — rented at cost by peers. 👯"/>
        <OnboardingDescription text="You can rent out your space too!🥂"/>
      </div>
    </div>
  );
};

export default Step1; 